import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import Loading from '@/components/UI/loading';
import { SignOutUser } from '../../store/Auth';

export const Logout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const logoutInProgress = useRef(false);

  useEffect(() => {
    // Prevent multiple logout calls
    if (logoutInProgress.current) {
      return;
    }

    logoutInProgress.current = true;

    // Call the sign_out API and wait for it to complete before navigating
    const performLogout = async () => {
      try {
        await dispatch(SignOutUser() as any);
      } catch (error) {
        console.error('Logout error:', error);
      } finally {
        // Navigate to login regardless of success/failure
        navigate('/auth/sign_in', { replace: true });
      }
    };

    performLogout();
  }, [dispatch, navigate]);

  return <Loading loadingText='Logging Out...' />;
};
